import { PRESALE_START_DATE_DISPLAY as PRESALE_DATE } from './presaleConfig';
import { IS_TEST_MODE } from '../contracts/addresses'; // Importar la variable centralizada

const initialSupply = 700;
const totalToDistribute = 300;

// Usamos IS_TEST_MODE en lugar de tener una variable separada
export const TEST_MODE = IS_TEST_MODE;

// Exportamos la fecha desde presaleConfig.js
export const PRESALE_START_DATE_DISPLAY = PRESALE_DATE;

const stakingData = [
  { month: "Jun 2025", amount: initialSupply + 12.5 }, // First month starts at 700M + 12.5M
  { month: "Jul 2025", amount: initialSupply + 25 }, // Cumulative amount
  { month: "Aug 2025", amount: initialSupply + 37.5 },
  { month: "Sep 2025", amount: initialSupply + 50 },
  { month: "Oct 2025", amount: initialSupply + 62.5 },
  { month: "Nov 2025", amount: initialSupply + 75 },
  { month: "Dec 2025", amount: initialSupply + 87.5 },
  { month: "Jan 2026", amount: initialSupply + 100 },
  { month: "Feb 2026", amount: initialSupply + 112.5 },
  { month: "Mar 2026", amount: initialSupply + 125 },
  { month: "Apr 2026", amount: initialSupply + 137.5 },
  { month: "May 2026", amount: initialSupply + 150 },
  { month: "Jun 2026", amount: initialSupply + 162.5 },
  { month: "Jul 2026", amount: initialSupply + 175 },
  { month: "Aug 2026", amount: initialSupply + 187.5 },
  { month: "Sep 2026", amount: initialSupply + 200 },
  { month: "Oct 2026", amount: initialSupply + 212.5 },
  { month: "Nov 2026", amount: initialSupply + 225 },
  { month: "Dec 2026", amount: initialSupply + 237.5 },
  { month: "Jan 2027", amount: initialSupply + 250 },
  { month: "Feb 2027", amount: initialSupply + 262.5 },
  { month: "Mar 2027", amount: initialSupply + 275 },
  { month: "Apr 2027", amount: initialSupply + 287.5 },
  { month: "May 2027", amount: initialSupply + totalToDistribute }, // Last month reaches 1000M
];

export default stakingData;
